const log10 = (num) => (Math.round((Math.log(num) / Math.LN10) * 1e6) / 1e6);

export const sigfig = (num, sigfigsOpt) => {
  // Set default sigfigs to 3
  const funcSigfigsOpt = (typeof sigfigsOpt === 'undefined') ? 3 : sigfigsOpt;
  // Only assigns sig figs and suffixes for numbers > 1
  if (num <= 1) return num.toPrecision(sigfigsOpt);
  // Calculate for numbers > 1
  const power10 = log10(num);
  // 0 = '', 1 = 'K', 2 = 'M', 3 = 'B', 4 = 'T'
  const SUFFIXES = ['', 'K', 'M', 'B', 'T'];
  // 100: power10 = 2, suffixNum = 0, suffix = ''
  // 1000: power10 = 3, suffixNum = 1, suffix = 'K'
  const suffixNum = Math.floor(power10 / 3);
  const suffix = SUFFIXES[suffixNum];
  const suffixPower10 = 10 ** (suffixNum * 3);
  const base = num / suffixPower10;
  const baseRound = base.toPrecision(funcSigfigsOpt);
  return baseRound + suffix;
};

export const numberWithDots = (x) => {
  if (!x) return 0;
  const num = Math.round(x * 100) / 100;
  const str = num.toString().replace('.', ',');
  return str.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
